// extracted by mini-css-extract-plugin
export default {"container":"Products_container__or0bQ","Products":"Products_Products__A7sfA","menu":"Products_menu__gqQFu","list":"Products_list__7fEd-","Product":"Products_Product__NTtsA"};